// Account type governs how much of the admin portal an administrator sees.
//
// An administrator signs up as either "enterprise" or "freelance"
// (admin_details.account_type). Enterprise accounts get the full portal;
// freelance accounts get a restricted portal with the vendor, manager,
// client pool, jobs and payables modules removed.
//
// account_type is only present on the administrator role (null for managers,
// vendors, etc.), so `isFreelance` is false for every non-admin user.

export const ENTERPRISE = "enterprise";
export const FREELANCE = "freelance";

export const isFreelance = (user) => user?.account_type === FREELANCE;

export const isProjectManager = (user) => user?.roleSlug === "project_manager";

export const isAccountManager = (user) => user?.roleSlug === "account_manager";